module.exports = __webpack_public_path__ + "img/Dashboard.1c2cf3ba.svg";